<template>
  <div v-if="props.adminView" class="relative flex items-start">
    <div class="flex h-6 items-center">
      <input
        :id="model.key"
        :aria-describedby="`${model.label}-description`"
        :name="model.key"
        v-model="model.data.checked"
        :disabled="props.disabled"
        @change="customChange"
        type="checkbox"
        class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
      />
    </div>
    <div class="ml-3 text-sm leading-6">
      <label :for="model.key" class="mt-1 text-sm text-gray-900">
        {{ getPeriodTime(model) }}
      </label>
    </div>
    <div class="">
      <div class="bg-white rounded-md my-2" :id="'outer-error_' + model.key">
        <p
          class="font-medium text-sm text-red-2"
          :id="'error_' + model.key"
        ></p>
      </div>
    </div>
  </div>
  <div v-else class="mt-2 block">
    <label :for="model.key" data-dashlane-label="true">
      <div class="relative">
        <input
          class="disabled:bg-gray-2 disabled:text-gray-2 disabled:cursor-not-allowed disabled:border-gray-2"
          type="checkbox"
          v-model="model.data.checked"
          @change="customChange"
          :id="id"
          :name="model.key"
          :disabled="props.disabled ? true : null"
        />

        <span
          class="px-2"
          :id="'inner-text_' + model.key"
          v-if="model.isHtml"
          v-html="model.label"
        ></span>
        <label
          :for="model.key"
          class="px-2"
          :id="'inner-text_' + model.key"
          v-if="!model.isHtml"
        >
          {{ model.label }}
        </label>
        <div
          :id="'icon-error_' + model.key"
          class="hidden absolute top-[3px] right-0 left-auto w-[20px] flex flex-row justify-center items-center"
          @mouseenter="showErrorMessage"
          @mouseleave="hideErrorMessage"
        >
          <i class="text-red-2 fa-solid fa-circle-info"></i>
        </div>
      </div>
      <div v-show="showingErrorMessage" class="relative z-50">
        <div
          class="absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md"
          :id="'outer-error_' + model.key"
        >
          <p
            class="font-medium text-sm text-red-2"
            :id="'error_' + model.key"
          ></p>
        </div>
      </div>
    </label>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { DynamicProperty } from "@/models/dtos";

const emit = defineEmits(["change"]);
const props = defineProps({
  model: {
    type: DynamicProperty,
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
});
let model = ref(props.model);

function customChange() {
  emit("change", model.value);
}
function getPeriodTime(item: DynamicProperty) {
  return `${item.data.startDate} - ${item.data.endDate}`;
}
const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};
</script>
